<template>
  <section class="cf-page-container">
    <cf-menu-list
      class="cf-margin-top-16"
      :is-category-card-layout="isCategoryCardLayout"
      :is-read-only="isReadOnly"
    />

    <!-- Router View -->
    <router-view />
  </section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfMenuList from '@/view/components/globals/cf-menu-list/index.vue';


  export default {
    name: 'OrderAtTableMenuPage',

    components: {
      CfMenuList
    },

    metaInfo() {
      return {
        title: 'Menu'
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['session', 'isTableTopDeviceOrdering']),
      ...mapGetters('socket', ['orderRoom']),

      isCategoryCardLayout() {
        return this.merchant.features['order-at-table-menu-category'];
      },

      isReadOnly() {
        return this.merchant.features['readonly-order-at-table'];
      },

      isAgeVerficationRequiredForMenu() {
        return this.merchant.features['age-restricted'] && !this.session.hasVerifiedAgeForAlcohol;
      }
    },

    watch: {
      'orderRoom.status': {
        handler: 'orderRoomStatusChangeHandler',
        immediate: true
      }
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      onComponentCreated() {
        if (this.isAgeVerficationRequiredForMenu) {
          this.$openModal('ageVerificationModal', { required: true });
        }

        this.$store.dispatch('merchant/openInAppMessage', { type: 'Menu' });
      },

      orderRoomStatusChangeHandler(status) {
        if (status === 'closed') {
          this.$router.go(0);
        }

        if (status === 'locked') {
          if (this.isTableTopDeviceOrdering) {
            this.$router.push({
              name: 'orderAtTableCartSummaryPage',
              params: { merchantId: this.$route.params.merchantId },
              query: { tb: this.session.route.tableNumber, ttd: 1 }
            });
          }
          else {
            this.$router.replace({
              name: 'payAtTableCheckout',
              params: {
                merchantId: this.$route.params.merchantId
              },
              query: {
                ml: this.session.route.merchantLocationId,
                oi: this.session.route.orderId,
                tb: this.session.route.tableNumber
              }
            });

            this.$closeAllModals();
          }
        }
      }
    }
  };
</script>
